import { Component, OnInit,ViewEncapsulation,Inject,Input } from '@angular/core';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import {NgForm} from '@angular/forms';
import {FormControl} from '@angular/forms';
import {Router} from '@angular/router';
import { DummydataService } from '../../../services/dummydata/dummydata.service';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {MAT_BOTTOM_SHEET_DATA} from '@angular/material/bottom-sheet';
import { FollowerOFBoards} from '../../../modele/boardModel';

@Component({
  selector: 'app-follower-from-board',
  templateUrl: './follower-from-board.component.html',
  styleUrls: ['./follower-from-board.component.scss']
})
export class FollowerFromBoardComponent implements OnInit {
        @Input() item:any;
        searchValue = new FormControl();
        public board_name: string;
        followerList: FollowerOFBoards[] = [];
        followerListLength: number;
        filteredStates: Observable<FollowerOFBoards[]>;
        userLen;
        boardFollowerCount: number;
        value;
        _filterLen;


        constructor(
          private router: Router,
          @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
          private dummydata: DummydataService,
          private bottomSheet: MatBottomSheet,

          ) {
              this.filteredStates = this.searchValue.valueChanges.pipe(
                  startWith(''),
                  map(user => user ? this._filterStates(user) : this.followerList.slice()));
            }
            private _filterStates(value: string): FollowerOFBoards[] {
                const filterValue = value.toLowerCase();
                this.userLen = this.followerList.length - this.followerList.filter(user => user.user_name.toLowerCase().indexOf(filterValue)).length;
                return this.followerList.filter(user => user.user_name.toLowerCase().indexOf(filterValue) === 0);
           }

        ngOnInit() {
            this.getFollowerList();
        }
        onSubmitSuche(f: NgForm) {
        this.router.navigate(["/", this.searchValue.value]);
        }
        closeBottomSheet(){
            this.bottomSheet.dismiss();
        }

        getFollowerList(){
            this.followerListLength = this.dummydata.getFollowerList().length;

            let datafromBES = this.data['data']['result']
            datafromBES.map(data=>{
                this.board_name = data.board_screenname
                this.boardFollowerCount = data.board_follower_count
                data.following_users.map(userdata=>{
                    let followerList = new FollowerOFBoards(
                        userdata.user_id,
                        userdata.user_name,
                        userdata.user_avatar,
                        userdata.user_city,
                        userdata.user_is_verified
                    )
                    this.followerList.push(followerList)
                })
            })
        }
    }
